<div class="photo-container">
    <div class="video-container">
        <video
          [class.show]="!isCaptured"
          [class.hide]="isCaptured"
          #video
          id="video"
          [width]="WIDTH"
          [height]="HEIGHT"
          autoplay
        ></video>
        <canvas
        [class.show]="isCaptured"
        [class.hide]="!isCaptured"
        #canvas
        id="canvas"
        [width]="WIDTH"
        [height]="HEIGHT"
      ></canvas>
    </div>
      
    <div class="snap-container">
    <button class="btn btn-primary" *ngIf="!isCaptured" (click)="capture()">
        Snap Photo
    </button>
    </div>
</div>